// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   Rich Editor Container
   ============================================================================ */

.rich-editor-container {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  overflow: hidden;
}

.rich-editor-loading {
  padding: 20px;
  text-align: center;
  color: var(--text-secondary);
  font-style: italic;
}

/* ============================================================================
   Toolbar Styling
   ============================================================================ */

.rich-editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 12px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-primary);
  align-items: center;
}

.toolbar-group {
  display: flex;
  gap: 2px;
  padding: 0 4px;
  border-right: 1px solid var(--border-color);
}

.mode-switch-group .toolbar-btn {
  min-width: 60px;
}

.heading-label {
  display: inline-flex;
  align-items: center;
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin-right: 6px;
}

.heading-select {
  border: 1px solid var(--border-color);
  background: var(--input-bg);
  color: var(--input-text);
  border-radius: 4px;
  height: 32px;
  padding: 0 8px;
  font-size: 0.86rem;
}

.toolbar-group:last-of-type {
  border-right: none;
}

.toolbar-btn {
  padding: 6px 10px;
  border: 1px solid var(--border-color);
  background: var(--input-bg);
  color: var(--input-text);
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.toolbar-btn:hover:not(:disabled) {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
}

.toolbar-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.toolbar-btn.active {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
}

.toolbar-btn-highlight {
  padding: 6px 8px;
}

.toolbar-highlight-label {
  display: inline-block;
  color: black;
  background: yellow;
  padding: 0 2px;
  border-radius: 2px;
  line-height: 1.2;
}

.toolbar-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.character-counter {
  margin-left: auto;
  font-size: 0.85rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

.character-counter.limit-reached {
  color: var(--error-color);
  font-weight: bold;
}

.syntax-modal-content {
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  /* max-width: 500px; */
  /* width: 90%; */
  max-height: 80vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease;
  z-index: 1000;
  position: relative;
}

.syntax-modal-overlay {
  align-items: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width:100%;
  z-index: 999;
}

.syntax-guide-title {
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.syntax-guide-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 12px;
}

.syntax-guide-hint {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-bottom: 0.5rem;
}

.syntax-guide-subtitle {
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.syntax-guide code {
  display: block;
  background: var(--input-bg);
  color: var(--input-text);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 0.78rem;
  margin-bottom: 5px;
  word-break: break-word;
}

.syntax-guide-note {
  margin-top: 8px;
  font-size: 0.78rem;
  color: var(--text-secondary);
}

/* ============================================================================
   Editor Content
   ============================================================================ */

.rich-editor {
  position: relative;
  flex: 1 1;
  overflow: visible;
  max-height: none;
  background: var(--input-bg);
  color: var(--input-text);
}

.rich-editor .ProseMirror {
  min-height: 150px;
  padding: 16px;
  outline: none;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-family: inherit;
  line-height: 1.6;
  /* Allow touch/pointer events to correctly position the cursor on mobile */
  touch-action: manipulation;
  -webkit-user-select: text;
  user-select: text;
  cursor: text;
}

.rich-editor-textarea {
  width: 100%;
  min-height: 220px;
  border: none;
  outline: none;
  resize: none;
  overflow: hidden;
  background: var(--input-bg);
  color: var(--input-text);
  padding: 16px;
  line-height: 1.6;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}

.rich-editor-text-mentions {
  margin: 8px 12px 12px;
}

.rich-editor .ProseMirror:focus {
  outline: none;
}

.rich-editor .ProseMirror p {
  margin: 0.5em 0;
}

.rich-editor .ProseMirror img + p {
  min-height: 1.2em;
  clear: both;
  margin-top: 1em !important;
}

.rich-editor .ProseMirror img + p > br.ProseMirror-trailingBreak:only-child {
  display: block;
  line-height: 1.2em;
}

.rich-editor .ProseMirror h1 {
  font-size: 2em;
  font-weight: bold;
  margin: 0.67em 0;
}

.rich-editor .ProseMirror h2 {
  font-size: 1.5em;
  font-weight: bold;
  margin: 0.75em 0;
}

.rich-editor .ProseMirror h3 {
  font-size: 1.2em;
  font-weight: bold;
  margin: 0.83em 0;
}

.rich-editor .ProseMirror blockquote {
  border-left: 3px solid var(--accent-primary);
  padding-left: 12px;
  margin: 0.5em 0;
  color: var(--text-secondary);
  font-style: italic;
}

.rich-editor .ProseMirror code {
  background: rgba(0, 0, 0, 0.1);
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
}

.rich-editor .ProseMirror pre {
  background: rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
  margin: 1em 0;
}

.rich-editor .ProseMirror pre code {
  background: none;
  padding: 0;
  border-radius: 0;
}

.rich-editor .ProseMirror ul {
  list-style: disc;
  padding-left: 20px;
  margin: 0.5em 0;
}

.rich-editor .ProseMirror ol {
  list-style: decimal;
  padding-left: 20px;
  margin: 0.5em 0;
}

.rich-editor .ProseMirror img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin: 8px 0;
}

.rich-editor .ProseMirror img[data-align='left'],
.rich-editor .ProseMirror img.text-left {
  display: block;
  margin: 8px auto 8px 0 !important;
}

.rich-editor .ProseMirror img[data-align='center'],
.rich-editor .ProseMirror img.text-center {
  display: block;
  margin: 8px auto !important;
}

.rich-editor .ProseMirror img[data-align='right'],
.rich-editor .ProseMirror img.text-right {
  display: block;
  margin: 8px 0 8px auto !important;
}

.rich-editor .ProseMirror iframe.shortapp-editor-video-embed {
  display: block;
  width: 100%;
  min-height: 320px;
  aspect-ratio: 16 / 9;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: #000;
  margin: 10px 0;
}

.rich-editor .ProseMirror iframe.shortapp-editor-video-embed + p {
  min-height: 1.2em;
  clear: both;
  margin-top: 1em !important;
}

.rich-editor .ProseMirror iframe.shortapp-editor-video-embed + p > br.ProseMirror-trailingBreak:only-child {
  display: block;
  line-height: 1.2em;
}

.rich-editor .ProseMirror a.shortapp-editor-video-link {
  display: block;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-secondary);
  padding: 10px 12px;
  margin: 8px 0;
  font-weight: 600;
  text-decoration: none;
  word-break: break-all;
  position: relative;
  padding-left: 44px;
  overflow: hidden;
}

.rich-editor .ProseMirror a.shortapp-editor-video-link::before {
  content: '▶';
  display: inline-flex;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  align-items: center;
  justify-content: center;
  font-size: 0.72rem;
  font-weight: 700;
  color: #fff;
  background: var(--accent-primary);
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.rich-editor .ProseMirror .shortapp-editor-video-title {
  display: block;
}

.rich-editor .ProseMirror a.shortapp-editor-video-link:hover {
  text-decoration: underline;
}

.rich-editor .ProseMirror a:not(.shortapp-editor-video-link) {
  color: var(--accent-primary);
  text-decoration: underline;
  cursor: pointer;
}

.rich-editor .ProseMirror a:not(.shortapp-editor-video-link):hover {
  opacity: 0.8;
}

.rich-editor .ProseMirror hr {
  border: none;
  border-top: 1px solid var(--border-color);
  margin: 1em 0;
}

/* ============================================================================
   Placeholder
   ============================================================================ */

.rich-editor .ProseMirror.is-empty::before {
  content: attr(data-placeholder);
  float: left;
  color: var(--text-secondary);
  pointer-events: none;
  height: 0;
  font-style: italic;
}

/* ============================================================================
   Modal Styles
   ============================================================================ */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-color);
}

.modal-header h3 {
  margin: 0;
  font-size: 1.1rem;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: var(--text-primary);
}

.modal-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: var(--input-bg);
  color: var(--input-text);
  font-size: 0.95rem;
  margin: 8px 0;
  font-family: inherit;
  box-sizing: border-box;
}

.modal-input:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 2px rgba(var(--accent-primary-rgb), 0.1);
}

.modal-divider {
  text-align: center;
  margin: 12px 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.modal-align-label {
  font-size: 0.8rem;
  font-style: italic;
  color: var(--text-secondary);
  margin-bottom: 4px;
  text-align: center;
}

.modal-align-group {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.modal-align-group-compact {
  margin-top: 0;
}

.modal-align-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--border-color);
  background: var(--input-bg);
  color: var(--input-text);
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 0.85rem;
}

.modal-align-option input[type='radio'] {
  accent-color: var(--accent-primary);
  margin: 0;
}

.modal-align-option:hover {
  border-color: var(--accent-primary);
}

.modal-footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border-color);
}

.btn-primary,
.btn-secondary {
  padding: 8px 16px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  font-weight: 500;
}

.btn-primary {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
}

.btn-primary:hover:not(:disabled) {
  opacity: 0.9;
}

.btn-secondary {
  background: var(--input-bg);
  color: var(--input-text);
  border-color: var(--border-color);
}

.btn-secondary:hover:not(:disabled) {
  background: var(--bg-primary);
}

.btn-primary:disabled,
.btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.file-input-hidden {
  display: none;
}

.file-upload-btn {
  display: inline-block;
  padding: 8px 16px;
  background: var(--input-bg);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  text-align: center;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  margin: 8px 0;
}

.file-upload-btn:hover {
  background: var(--bg-primary);
}

/* ============================================================================
   Emoji Picker
   ============================================================================ */

.emoji-picker-container {
  position: absolute;
  bottom: 60px;
  left: 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 12px;
  z-index: 500;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.emoji-picker-header {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.emoji-search-input {
  flex: 1 1;
  padding: 8px 10px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--input-bg);
  color: var(--input-text);
}

.emoji-close-btn {
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 8px 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  cursor: pointer;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 4px;
}

.emoji-btn {
  width: 40px;
  height: 40px;
  border: 1px solid var(--border-color);
  background: var(--input-bg);
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
}

.emoji-btn:hover {
  background: var(--accent-primary);
  transform: scale(1.1);
}

/* ============================================================================
   GIF Search
   ============================================================================ */

.gif-search-container {
  position: absolute;
  bottom: 60px;
  left: 200px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 12px;
  z-index: 500;
  max-width: 400px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.gif-search-header {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.gif-search-input {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: var(--input-bg);
  color: var(--input-text);
  font-size: 0.9rem;
}

.gif-search-input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.gif-results {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  overflow-y: auto;
  flex: 1 1;
}

.gif-empty-state {
  font-size: 0.88rem;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.gif-result-item {
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  transition: transform 0.2s ease;
  border: 1px solid var(--border-color);
}

.gif-result-item:hover {
  transform: scale(1.05);
}

.gif-thumbnail {
  width: 100%;
  height: 120px;
  object-fit: cover;
  display: block;
}

/* ============================================================================
   Responsive
   ============================================================================ */

@media (max-width: 768px) {
  .rich-editor-toolbar {
    gap: 2px;
    padding: 8px;
  }

  .toolbar-btn {
    padding: 4px 8px;
    min-width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }

  .rich-editor .ProseMirror {
    min-height: 120px;
    padding: 12px;
  }

  .modal-content {
    max-width: 90%;
  }

  .emoji-grid {
    grid-template-columns: repeat(4, 1fr);
  }

  .gif-results {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .rich-editor-toolbar {
    gap: 1px;
    padding: 6px;
  }

  .toolbar-group {
    gap: 1px;
    padding: 0 2px;
  }

  .toolbar-btn {
    padding: 4px 6px;
    min-width: 24px;
    height: 24px;
    font-size: 0.75rem;
  }

  .rich-editor {
    max-height: 300px;
  }

  .emoji-picker-container {
    left: 0;
    right: 0;
    width: calc(100% - 24px);
    margin: 12px;
  }

  .gif-search-container {
    left: 0;
    right: 0;
    width: calc(100% - 24px);
    margin: 12px;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RichEditor/RichEditor.css"],"names":[],"mappings":"AAAA;;iFAEiF;;AAEjF;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;iFAEiF;;AAEjF;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,4CAA4C;EAC5C,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;iFAEiF;;AAEjF;EACE,kBAAkB;EAClB,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,0EAA0E;EAC1E,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,+GAA+G;AACjH;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,aAAa;AACf;;AAEA;;iFAEiF;;AAEjF;EACE,+BAA+B;EAC/B,WAAW;EACX,4BAA4B;EAC5B,oBAAoB;EACpB,SAAS;EACT,kBAAkB;AACpB;;AAEA;;iFAEiF;;AAEjF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;EAEE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;iFAEiF;;AAEjF;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;iFAEiF;;AAEjF;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;iFAEiF;;AAEjF;EACE;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,wBAAwB;IACxB,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* ============================================================================\r\n   Rich Editor Container\r\n   ============================================================================ */\r\n\r\n.rich-editor-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  overflow: hidden;\r\n}\r\n\r\n.rich-editor-loading {\r\n  padding: 20px;\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n  font-style: italic;\r\n}\r\n\r\n/* ============================================================================\r\n   Toolbar Styling\r\n   ============================================================================ */\r\n\r\n.rich-editor-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  padding: 12px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  background: var(--bg-primary);\r\n  align-items: center;\r\n}\r\n\r\n.toolbar-group {\r\n  display: flex;\r\n  gap: 2px;\r\n  padding: 0 4px;\r\n  border-right: 1px solid var(--border-color);\r\n}\r\n\r\n.mode-switch-group .toolbar-btn {\r\n  min-width: 60px;\r\n}\r\n\r\n.heading-label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  font-size: 0.82rem;\r\n  color: var(--text-secondary);\r\n  margin-right: 6px;\r\n}\r\n\r\n.heading-select {\r\n  border: 1px solid var(--border-color);\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n  border-radius: 4px;\r\n  height: 32px;\r\n  padding: 0 8px;\r\n  font-size: 0.86rem;\r\n}\r\n\r\n.toolbar-group:last-of-type {\r\n  border-right: none;\r\n}\r\n\r\n.toolbar-btn {\r\n  padding: 6px 10px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n  min-width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.toolbar-btn:hover:not(:disabled) {\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.toolbar-btn:active:not(:disabled) {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.toolbar-btn.active {\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.toolbar-btn-highlight {\r\n  padding: 6px 8px;\r\n}\r\n\r\n.toolbar-highlight-label {\r\n  display: inline-block;\r\n  color: black;\r\n  background: yellow;\r\n  padding: 0 2px;\r\n  border-radius: 2px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.toolbar-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.character-counter {\r\n  margin-left: auto;\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n  white-space: nowrap;\r\n}\r\n\r\n.character-counter.limit-reached {\r\n  color: var(--error-color);\r\n  font-weight: bold;\r\n}\r\n\r\n.syntax-modal-content {\r\n  max-height: calc(100vh - 2rem);\r\n  overflow-y: auto;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  /* max-width: 500px; */\r\n  /* width: 90%; */\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  animation: slideUp 0.3s ease;\r\n  z-index: 1000;\r\n  position: relative;\r\n}\r\n\r\n.syntax-modal-overlay {\r\n  align-items: flex-start;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  width:100%;\r\n  z-index: 999;\r\n}\r\n\r\n.syntax-guide-title {\r\n  font-size: 0.92rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.syntax-guide-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.syntax-guide-hint {\r\n  font-size: 0.75rem;\r\n  color: var(--text-muted);\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.syntax-guide-subtitle {\r\n  font-size: 0.8rem;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 6px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.syntax-guide code {\r\n  display: block;\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  padding: 4px 6px;\r\n  font-size: 0.78rem;\r\n  margin-bottom: 5px;\r\n  word-break: break-word;\r\n}\r\n\r\n.syntax-guide-note {\r\n  margin-top: 8px;\r\n  font-size: 0.78rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ============================================================================\r\n   Editor Content\r\n   ============================================================================ */\r\n\r\n.rich-editor {\r\n  position: relative;\r\n  flex: 1;\r\n  overflow: visible;\r\n  max-height: none;\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n}\r\n\r\n.rich-editor .ProseMirror {\r\n  min-height: 150px;\r\n  padding: 16px;\r\n  outline: none;\r\n  word-wrap: break-word;\r\n  white-space: pre-wrap;\r\n  font-family: inherit;\r\n  line-height: 1.6;\r\n  /* Allow touch/pointer events to correctly position the cursor on mobile */\r\n  touch-action: manipulation;\r\n  -webkit-user-select: text;\r\n  user-select: text;\r\n  cursor: text;\r\n}\r\n\r\n.rich-editor-textarea {\r\n  width: 100%;\r\n  min-height: 220px;\r\n  border: none;\r\n  outline: none;\r\n  resize: none;\r\n  overflow: hidden;\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n  padding: 16px;\r\n  line-height: 1.6;\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;\r\n}\r\n\r\n.rich-editor-text-mentions {\r\n  margin: 8px 12px 12px;\r\n}\r\n\r\n.rich-editor .ProseMirror:focus {\r\n  outline: none;\r\n}\r\n\r\n.rich-editor .ProseMirror p {\r\n  margin: 0.5em 0;\r\n}\r\n\r\n.rich-editor .ProseMirror img + p {\r\n  min-height: 1.2em;\r\n  clear: both;\r\n  margin-top: 1em !important;\r\n}\r\n\r\n.rich-editor .ProseMirror img + p > br.ProseMirror-trailingBreak:only-child {\r\n  display: block;\r\n  line-height: 1.2em;\r\n}\r\n\r\n.rich-editor .ProseMirror h1 {\r\n  font-size: 2em;\r\n  font-weight: bold;\r\n  margin: 0.67em 0;\r\n}\r\n\r\n.rich-editor .ProseMirror h2 {\r\n  font-size: 1.5em;\r\n  font-weight: bold;\r\n  margin: 0.75em 0;\r\n}\r\n\r\n.rich-editor .ProseMirror h3 {\r\n  font-size: 1.2em;\r\n  font-weight: bold;\r\n  margin: 0.83em 0;\r\n}\r\n\r\n.rich-editor .ProseMirror blockquote {\r\n  border-left: 3px solid var(--accent-primary);\r\n  padding-left: 12px;\r\n  margin: 0.5em 0;\r\n  color: var(--text-secondary);\r\n  font-style: italic;\r\n}\r\n\r\n.rich-editor .ProseMirror code {\r\n  background: rgba(0, 0, 0, 0.1);\r\n  padding: 2px 6px;\r\n  border-radius: 3px;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.rich-editor .ProseMirror pre {\r\n  background: rgba(0, 0, 0, 0.1);\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n  overflow-x: auto;\r\n  margin: 1em 0;\r\n}\r\n\r\n.rich-editor .ProseMirror pre code {\r\n  background: none;\r\n  padding: 0;\r\n  border-radius: 0;\r\n}\r\n\r\n.rich-editor .ProseMirror ul {\r\n  list-style: disc;\r\n  padding-left: 20px;\r\n  margin: 0.5em 0;\r\n}\r\n\r\n.rich-editor .ProseMirror ol {\r\n  list-style: decimal;\r\n  padding-left: 20px;\r\n  margin: 0.5em 0;\r\n}\r\n\r\n.rich-editor .ProseMirror img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 4px;\r\n  margin: 8px 0;\r\n}\r\n\r\n.rich-editor .ProseMirror img[data-align='left'],\r\n.rich-editor .ProseMirror img.text-left {\r\n  display: block;\r\n  margin: 8px auto 8px 0 !important;\r\n}\r\n\r\n.rich-editor .ProseMirror img[data-align='center'],\r\n.rich-editor .ProseMirror img.text-center {\r\n  display: block;\r\n  margin: 8px auto !important;\r\n}\r\n\r\n.rich-editor .ProseMirror img[data-align='right'],\r\n.rich-editor .ProseMirror img.text-right {\r\n  display: block;\r\n  margin: 8px 0 8px auto !important;\r\n}\r\n\r\n.rich-editor .ProseMirror iframe.shortapp-editor-video-embed {\r\n  display: block;\r\n  width: 100%;\r\n  min-height: 320px;\r\n  aspect-ratio: 16 / 9;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  background: #000;\r\n  margin: 10px 0;\r\n}\r\n\r\n.rich-editor .ProseMirror iframe.shortapp-editor-video-embed + p {\r\n  min-height: 1.2em;\r\n  clear: both;\r\n  margin-top: 1em !important;\r\n}\r\n\r\n.rich-editor .ProseMirror iframe.shortapp-editor-video-embed + p > br.ProseMirror-trailingBreak:only-child {\r\n  display: block;\r\n  line-height: 1.2em;\r\n}\r\n\r\n.rich-editor .ProseMirror a.shortapp-editor-video-link {\r\n  display: block;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  background: var(--bg-secondary);\r\n  padding: 10px 12px;\r\n  margin: 8px 0;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  word-break: break-all;\r\n  position: relative;\r\n  padding-left: 44px;\r\n  overflow: hidden;\r\n}\r\n\r\n.rich-editor .ProseMirror a.shortapp-editor-video-link::before {\r\n  content: '▶';\r\n  display: inline-flex;\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 999px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  background: var(--accent-primary);\r\n  position: absolute;\r\n  left: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.rich-editor .ProseMirror .shortapp-editor-video-title {\r\n  display: block;\r\n}\r\n\r\n.rich-editor .ProseMirror a.shortapp-editor-video-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.rich-editor .ProseMirror a:not(.shortapp-editor-video-link) {\r\n  color: var(--accent-primary);\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n\r\n.rich-editor .ProseMirror a:not(.shortapp-editor-video-link):hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.rich-editor .ProseMirror hr {\r\n  border: none;\r\n  border-top: 1px solid var(--border-color);\r\n  margin: 1em 0;\r\n}\r\n\r\n/* ============================================================================\r\n   Placeholder\r\n   ============================================================================ */\r\n\r\n.rich-editor .ProseMirror.is-empty::before {\r\n  content: attr(data-placeholder);\r\n  float: left;\r\n  color: var(--text-secondary);\r\n  pointer-events: none;\r\n  height: 0;\r\n  font-style: italic;\r\n}\r\n\r\n/* ============================================================================\r\n   Modal Styles\r\n   ============================================================================ */\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.2s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.modal-content {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  max-width: 500px;\r\n  width: 90%;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  animation: slideUp 0.3s ease;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(20px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.modal-header h3 {\r\n  margin: 0;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  padding: 0;\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.modal-close:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.modal-input {\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n  font-size: 0.95rem;\r\n  margin: 8px 0;\r\n  font-family: inherit;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.modal-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 0 0 2px rgba(var(--accent-primary-rgb), 0.1);\r\n}\r\n\r\n.modal-divider {\r\n  text-align: center;\r\n  margin: 12px 0;\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.modal-align-label {\r\n  font-size: 0.8rem;\r\n  font-style: italic;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 4px;\r\n  text-align: center;\r\n}\r\n\r\n.modal-align-group {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n}\r\n\r\n.modal-align-group-compact {\r\n  margin-top: 0;\r\n}\r\n\r\n.modal-align-option {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n  border-radius: 6px;\r\n  padding: 6px 10px;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.modal-align-option input[type='radio'] {\r\n  accent-color: var(--accent-primary);\r\n  margin: 0;\r\n}\r\n\r\n.modal-align-option:hover {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  margin-top: 16px;\r\n  padding-top: 12px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.btn-primary,\r\n.btn-secondary {\r\n  padding: 8px 16px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.95rem;\r\n  transition: all 0.2s ease;\r\n  font-weight: 500;\r\n}\r\n\r\n.btn-primary {\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.btn-primary:hover:not(:disabled) {\r\n  opacity: 0.9;\r\n}\r\n\r\n.btn-secondary {\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n  border-color: var(--border-color);\r\n}\r\n\r\n.btn-secondary:hover:not(:disabled) {\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.btn-primary:disabled,\r\n.btn-secondary:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.file-input-hidden {\r\n  display: none;\r\n}\r\n\r\n.file-upload-btn {\r\n  display: inline-block;\r\n  padding: 8px 16px;\r\n  background: var(--input-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.95rem;\r\n  text-align: center;\r\n  transition: all 0.2s ease;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  margin: 8px 0;\r\n}\r\n\r\n.file-upload-btn:hover {\r\n  background: var(--bg-primary);\r\n}\r\n\r\n/* ============================================================================\r\n   Emoji Picker\r\n   ============================================================================ */\r\n\r\n.emoji-picker-container {\r\n  position: absolute;\r\n  bottom: 60px;\r\n  left: 12px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  z-index: 500;\r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.emoji-picker-header {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.emoji-search-input {\r\n  flex: 1;\r\n  padding: 8px 10px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n}\r\n\r\n.emoji-close-btn {\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  padding: 8px 10px;\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n}\r\n\r\n.emoji-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, 1fr);\r\n  gap: 4px;\r\n}\r\n\r\n.emoji-btn {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--input-bg);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 1.2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease;\r\n  padding: 0;\r\n}\r\n\r\n.emoji-btn:hover {\r\n  background: var(--accent-primary);\r\n  transform: scale(1.1);\r\n}\r\n\r\n/* ============================================================================\r\n   GIF Search\r\n   ============================================================================ */\r\n\r\n.gif-search-container {\r\n  position: absolute;\r\n  bottom: 60px;\r\n  left: 200px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  z-index: 500;\r\n  max-width: 400px;\r\n  max-height: 400px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.gif-search-header {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.gif-search-input {\r\n  flex: 1;\r\n  padding: 8px 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  background: var(--input-bg);\r\n  color: var(--input-text);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.gif-search-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.gif-results {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 8px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.gif-empty-state {\r\n  font-size: 0.88rem;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.gif-result-item {\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  transition: transform 0.2s ease;\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.gif-result-item:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.gif-thumbnail {\r\n  width: 100%;\r\n  height: 120px;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n/* ============================================================================\r\n   Responsive\r\n   ============================================================================ */\r\n\r\n@media (max-width: 768px) {\r\n  .rich-editor-toolbar {\r\n    gap: 2px;\r\n    padding: 8px;\r\n  }\r\n\r\n  .toolbar-btn {\r\n    padding: 4px 8px;\r\n    min-width: 28px;\r\n    height: 28px;\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .rich-editor .ProseMirror {\r\n    min-height: 120px;\r\n    padding: 12px;\r\n  }\r\n\r\n  .modal-content {\r\n    max-width: 90%;\r\n  }\r\n\r\n  .emoji-grid {\r\n    grid-template-columns: repeat(4, 1fr);\r\n  }\r\n\r\n  .gif-results {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .rich-editor-toolbar {\r\n    gap: 1px;\r\n    padding: 6px;\r\n  }\r\n\r\n  .toolbar-group {\r\n    gap: 1px;\r\n    padding: 0 2px;\r\n  }\r\n\r\n  .toolbar-btn {\r\n    padding: 4px 6px;\r\n    min-width: 24px;\r\n    height: 24px;\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .rich-editor {\r\n    max-height: 300px;\r\n  }\r\n\r\n  .emoji-picker-container {\r\n    left: 0;\r\n    right: 0;\r\n    width: calc(100% - 24px);\r\n    margin: 12px;\r\n  }\r\n\r\n  .gif-search-container {\r\n    left: 0;\r\n    right: 0;\r\n    width: calc(100% - 24px);\r\n    margin: 12px;\r\n    max-width: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
